import { Component, OnInit } from '@angular/core';
import { ToastService } from '@core/services/toast/toast.service';
import { Toast } from '@core/services/toast/toast.types';

enum typesIcons {
  info = 'info',
  warning = 'warning',
  error = 'error',
  success = 'check_circle'
};

@Component({
  selector: 'toast-notification',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})

export class ToastComponent {
  toasts: Toast[] = [];
  typesIcons = typesIcons;
  isCollapsable: boolean = false;

  constructor(public toastService: ToastService) {
    toastService.toasts$
      .subscribe(toasts => this.toasts = toasts);
  }

  remove(id: string, index: number) {    
    this.toasts[index].isActive = true;
    setTimeout(()=>{ 
      this.toastService.remove(id);
    }, 1600);
  }

  removeAll() {
    this.isCollapsable = true;
    setTimeout(()=>{                           // <<<---using ()=> syntax
      this.toastService.removeAll();
      this.isCollapsable = false;
    }, 2000);
  }

  collapsable() {
    this.isCollapsable = !this.isCollapsable;
  }
}
